import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { Container } from '../styled';
import TypologyConfig from './TypologyConfig';
import TypologyRulesConfig from './TypologyRulesConfig';
import {
  createChallenger,
  fetchCurrentChampion,
  fetchSingleScenario
} from '../../../../redux/actions/trm/trmDashboard';

const Configuration = ({
  dispatch,
  scenarioId,
  isScheduled,
  isFraudPrevention,
  isScenarioLoading,
  isChampionLoading,
  singleScenarioData,
  currentChampionData
}) => {
  useEffect(() => {
    if (scenarioId) {
      dispatch(fetchSingleScenario({ scenarioID: scenarioId }));
    }
  }, [scenarioId]);

  useEffect(() => {
    if (singleScenarioData?.sourceId) {
      dispatch(
        fetchCurrentChampion({
          sourceId: singleScenarioData?.sourceId,
          scheduled: isScheduled
        })
      );
    }
  }, [singleScenarioData, isScheduled]);

  const onCreateChallenger = (values) => {
    dispatch(
      createChallenger({
        ...values,
        instanceId: singleScenarioData.latestInstance.id,
        scheduled: isScheduled
      })
    );
  };

  return (
    <Container>
      <Spin spinning={isScenarioLoading || isChampionLoading}>
        {isFraudPrevention ? (
          <TypologyRulesConfig
            typologies={singleScenarioData?.typologies || []}
            championTypologies={currentChampionData?.typologies || []}
            championTypologiesDetails={
              currentChampionData?.typologyDetails || []
            }
            onCreate={onCreateChallenger}
          />
        ) : (
          <TypologyConfig
            isScenarioLoading={isScenarioLoading}
            typologies={singleScenarioData?.categorizedTypologies || []}
            championTypologies={
              currentChampionData?.categorizedTypologies || []
            }
            onCreate={onCreateChallenger}
          />
        )}
      </Spin>
    </Container>
  );
};

Configuration.propTypes = {
  dispatch: PropTypes.func.isRequired,
  scenarioId: PropTypes.string,
  isScheduled: PropTypes.bool,
  isFraudPrevention: PropTypes.bool,
  singleScenarioData: PropTypes.object,
  currentChampionData: PropTypes.object,
  isScenarioLoading: PropTypes.bool,
  isChampionLoading: PropTypes.bool
};

Configuration.defaultProps = {
  isLoading: false
};

const mapStateToProps = ({
  trmDashboard: { singleScenario, currentChampion }
}) => ({
  singleScenarioData: singleScenario?.data,
  currentChampionData: currentChampion?.data,
  isScenarioLoading: singleScenario?.isLoading,
  isChampionLoading: currentChampion?.isLoading
});

export default connect(mapStateToProps)(Configuration);
